import axios from 'axios';
import { PRINT_AGENT_URL } from '../constants/picking';

/**
 * Send a PDF URL to the local print agent for silent printing.
 * Falls back to the iframe-based browser print dialog if the agent
 * is not running.
 */
export async function printViaPrintAgent(pdfUrl: string): Promise<boolean> {
  try {
    await axios.post(
      `${PRINT_AGENT_URL}/print`,
      { url: pdfUrl },
      { timeout: 10000 }
    );
    return true;
  } catch {
    return false;
  }
}

export async function isPrintAgentAvailable(): Promise<boolean> {
  try {
    await axios.get(`${PRINT_AGENT_URL}/health`, { timeout: 2000 });
    return true;
  } catch {
    return false;
  }
}
